module.exports = __webpack_public_path__ + "static/media/TODO.7949fa78.png";